import { ComputedRef, ref, Ref, watch } from 'vue';

export default function useScrollIntoView(scroll: Ref<boolean> | ComputedRef<boolean>, options: ScrollIntoViewOptions = { behavior: 'smooth' }) {
    const element: Ref<HTMLElement|undefined> = ref();
    const functionRef = el => {
        element.value = el;
    };

    watch(scroll, (scroll) => {
        if (scroll && element.value) {
            element.value.scrollIntoView(options);
        }
    }, { immediate: true });

    return functionRef;
}
